import { Box } from '@mui/material'
import { FeatureCategory } from '../../adminUserRestrictions/Restrictions.constants';
import { useUser } from '../../../context/UserContext';
import FeatureRestrictionDialog from '../../featureRestrictionDialog/FeatureRestrictionDialog';
import { useNavigate } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import { setFeatureRestrictionDialog } from '../../../reducer/user.reducer';
import { useDispatch } from 'react-redux';


interface Props {
    children: any
    featureCategory: FeatureCategory,
    featureSubCategory?: string,
    feature?: string,
    revertToHomePage?: boolean,
    name: string 
}
const ProductRestrictionWrapper = ({ children, featureCategory, featureSubCategory, feature, revertToHomePage = false, name }: Props) => {
    const { user: { hasAccess }} = useUser()
    const access = useMemo(()=>{
        return hasAccess(featureCategory, featureSubCategory, feature)
    },[hasAccess])
    const dispatch = useDispatch()
    useEffect(()=>{
        if(!access){
            dispatch(
                setFeatureRestrictionDialog({
                    open: true,
                    feature: name,
                    group: undefined,
                    revertToHome: revertToHomePage
                })
            )
        }
    },[access])
    return <Box sx={{ width: '100%', height: '100%' }}>
        {access ? children : null}
    </Box>
}

export default ProductRestrictionWrapper